import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Search() {
    const [search, setSearch] = useState('');
    const nav = useNavigate();
    const onSearch = (e: FormEvent) => {
        e.preventDefault();
        // @ts-ignore
        const input = (e.target as HTMLFormElement).elements['search'];
        const val = input.value;
        nav('/search/?q=' + val);
    };
    return (
        <div className="search">
            <form onSubmit={onSearch} className="iek-prodcat-catalog-section-filter-search">
                <input type="hidden" name="page" value="search" />
                <input
                    type="text"
                    name="search"
                    placeholder="Поиск по каталогу"
                    className="search__input iek-prodcat-catalog-section-filter-search__textbox"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <div className="search_icon iek-prodcat-catalog-section-filter-search__textbox-img" />
            </form>
        </div>
    );
}
export default Search;
